import { frontendURL } from 'dashboard/helper/URLHelper.js';
import Index from './Index.vue';

const meta = {
  permissions: ['administrator'],
};

const routes = [
  {
    path: frontendURL('accounts/:accountId/social-monitoring'),
    name: 'social_monitoring_dashboard',
    meta,
    component: Index,
  },
];

export default { routes };
